'use client';
import React from 'react';
import HeaderWrapper from '../components/HeaderWrapper';

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <HeaderWrapper hideNavLinks={false} />
      {children}
    </>
  );
}
